<template>
  <el-progress :percentage="progress" v-if="showProgress" />
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    showProgress: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
/* Add any custom styles here */
</style> 